'use client';

import { useTranslations } from 'next-intl';
import classNames from 'classnames';
import { Button, ButtonSize, ButtonType } from '@nx-frontend/shared/ui/button';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { Tooltip } from '@nx-frontend/shared/ui/tooltip';
import { OrganizationPrivilege } from '@nx-frontend/shared/types';
import { UiTooltipPosition } from '@nx-frontend/shared/types';

export function InviteMemberButton({
  buttonType,
  onClick,
  orgRolePrivileges,
}: {
  buttonType: string;
  onClick?: () => void;
  orgRolePrivileges: OrganizationPrivilege[];
}) {
  const t = useTranslations('webnotes');
  const isAllPages = buttonType === 'folders_root' || buttonType === 'allPage';

  const renderButton = () => (
    <Button
      data-cy={`${buttonType}-invite-button`}
      onClick={onClick}
      type={ButtonType.FLAT}
      size={isAllPages ? ButtonSize.XL : ButtonSize.XL2}
    >
      <Icon
        icon={IconsMap.USER_PLUS}
        className={classNames('w-5 h-5 mr-2', {
          'text-white': buttonType === 'allPage' || buttonType === 'folders' || buttonType === 'folders_root',
        })}
      />
      {isAllPages ? <span className="font-bold text-[13px] text-white">{t('webnotes-invite')}</span> : null}
      {buttonType === 'folders' ? (
        <span className="font-bold text-[13px] text-white ">{t('webnotes-manage_members')}</span>
      ) : null}
    </Button>
  );

  // currently we open popup with members invitation for org members that don't have CAN_ADD_MEMBERS privilege (workspace admins),
  // in the popup we can not invite clients, so we need to fix the tooltip to address this.
  // hint: clients can only be invited from the org panel
  let tooltip =
    orgRolePrivileges && orgRolePrivileges.includes(OrganizationPrivilege.CAN_ADD_MEMBERS)
      ? t('webnotes-invite_members_and_clients')
      : t('webnotes-invite_members');
  if (!isAllPages) {
    tooltip = t('webnotes-invite_members_and_clients');
  }

  return isAllPages ? (
    <Tooltip message={tooltip} position={UiTooltipPosition.BOTTOM}>
      {renderButton()}
    </Tooltip>
  ) : (
    renderButton()
  );
}
